import createNumberMask from 'text-mask-addons/dist/createNumberMask'

import { DiscountKind } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { formatDate, moneyMask } from '@avantstay/backoffice-core'

import { CreateQuoteFormProps } from '@new/domains/bookingsTapeChart/components/CreateQuoteForm/CreateQuoteForm.types'

import { NonBrandedQuoteHomes } from '@arriere/types/Quotes.types'

const parseCommonQuoteValues = (values: CreateQuoteFormProps) => {
  const { guests, pets, contact } = values
  return contact
    ? {
        pets,
        guests,
        contact: {
          fullName: contact.fullName,
          email: contact.email,
        },
      }
    : undefined
}

const centsToDollar = (amount: number) => amount / 100

export const parseRegularQuotesValues = (values: CreateQuoteFormProps, includeTaxes?: boolean) => {
  const commonValues = parseCommonQuoteValues(values)
  const { salesFrom, checkIn, checkOut, salesTo } = values

  if (commonValues && values.homes) {
    return {
      ...commonValues,
      includeTaxes,
      checkIn: checkIn ?? '',
      checkOut: checkOut ?? '',
      salesFrom: salesFrom ? formatDate(salesFrom) : undefined,
      salesTo: formatDate(salesTo),
      homes: values.homes.map(home => ({
        homeId: home.id ?? '',
        plainPrice: Number((home.guestView?.totalOfStay.total ?? 0).toFixed(2)),
        quotePrice: Number(centsToDollar(home.quotePrice ?? 0).toFixed(2)),
        depositPrice: Number(centsToDollar(home.deposits?.total ?? 0).toFixed(2)),
        discount: home.discount
          ? {
              discountKind: home.discount?.discountKind,
              discountAmount: home.discount?.discountAmount,
            }
          : undefined,
      })),
    }
  }
  return undefined
}

export const parseNoPriceQuotesValues = (values: CreateQuoteFormProps) => {
  const commonValues = parseCommonQuoteValues(values)

  if (commonValues && values.homes) {
    return {
      email: commonValues.contact.email,
      homeIds: values.homes.reduce(
        (accHomeIds: string[], home) => (home.id ? [...accHomeIds, home.id] : accHomeIds),
        [],
      ),
      request: {
        ...commonValues,
      },
    }
  }
  return undefined
}

export const parseNonBrandedQuotesValues = (values: CreateQuoteFormProps) => {
  const commonValues = parseCommonQuoteValues(values)

  if (commonValues && values.homes) {
    return {
      email: commonValues.contact.email,
      homes: values.homes.reduce(
        (accHomes: NonBrandedQuoteHomes[], home) =>
          home.id
            ? [
                ...accHomes,
                {
                  homeId: home.id,
                  shortDescription: home.shortDescription,
                  longDescription: home.longDescription,
                },
              ]
            : accHomes,
        [],
      ),
      request: {
        ...commonValues,
      },
    }
  }

  return undefined
}

export const getFieldsToSubmit = (formValues: CreateQuoteFormProps) => ({
  ...formValues,
  homes: formValues.homes?.filter(home => home.isHomeSelected),
})

export const getDiscountTypeOptions = () => [
  {
    value: DiscountKind.absolute,
    label: '$',
    mask: moneyMask,
  },
  {
    value: DiscountKind.percentage,
    label: '%',
    mask: createNumberMask({
      prefix: '% ',
      allowDecimal: true,
      decimalLimit: 2,
      integerLimit: 3,
    }),
  },
]
